import React, { createContext, useContext, useState } from 'react';
import { ROLES, ROLE_PERMISSIONS_MATRIX } from '../constants/permissions';
import { authService } from '../services/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem('admin_user');
    return saved ? JSON.parse(saved) : null;
  });

  const login = async (email, password, role = ROLES.SUPER_ADMIN) => {
    try {
      const data = await authService.login(email, password, role);
      setUser(data);
      localStorage.setItem('admin_user', JSON.stringify(data));
      localStorage.setItem('admin_token', data.token);
    } catch (err) {
      console.error('Login failed', err);
      throw err;
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('admin_user');
    localStorage.removeItem('admin_token');
  };

  const hasPermission = (permission) => {
    if (!user || !user.role) return false;
    const allowed = ROLE_PERMISSIONS_MATRIX[user.role] || [];
    return allowed.includes(permission);
  };

  const updateUser = (updatedFields) => {
    setUser((prev) => {
      const updated = { ...(prev || {}), ...updatedFields };
      localStorage.setItem('admin_user', JSON.stringify(updated));
      return updated;
    });
  };

  return (
    <AuthContext.Provider value={{ user, isAuthenticated: !!user, login, logout, updateUser, hasPermission }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => useContext(AuthContext);
